import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as navigationActions from "../../../../actions/navigationActions";
import * as settingsActions from "../../../../actions/settingsActions";
import * as rccActions from "../../../../actions/rccActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as rcc from "../../../../constants/rcc";
import * as config from "../../../../constants/config";
import * as resources from "../../../../constants/resources";
import * as formatHelper from "../../../../helpers/formatHelper";

import imgClean from "../../../../resources/img/svgicons/clean.svg";
import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";

class CleanChannelsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedChannels: [],
            cleaningTime: this.props.cleaningTime
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSelectAllClick = () => {
        this.setState({
            selectedChannels: this.getEnabledChannels()
        });
    };

    handleClearClick = () => {
        this.setState({
            selectedChannels: []
        });
    };

    handleToggleSelectChannelClick = (event) => {
        let channel = this.getChannelFromList(Number(event.target.dataset.id));

        if (channel !== null) {
            if (this.isChannelSelected(channel)) {
                this.setState({
                    selectedChannels: this.state.selectedChannels.filter((selected) => selected.id !== channel.id)
                });
            } else {
                this.setState({
                    selectedChannels: [...this.state.selectedChannels, channel]
                });
            }
        }
    };

    handleStartCleaningClick = () => {
        let channelIndexes = this.state.selectedChannels.map((channel) => channel.id);

        if (channelIndexes.length > 0 && Number(this.state.cleaningTime) > 0) {
            this.props.dispatchCloseModalAction();
            this.props.dispatchCleanChannelsAction(channelIndexes, Number(this.state.cleaningTime));
        }
    };

    handleCleaningTimeFocus = (event) => {
        event.target.select();
    };

    handleCleaningTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                cleaningTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleCleaningTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_CLEAN_TIME) {
            this.setState({cleaningTime: formatHelper.formatDecimal(value)});
            this.props.dispatchSetCleaningTimeAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({cleaningTime: rcc.RCC_MINIMAL_CLEAN_TIME});
            this.props.dispatchSetCleaningTimeAction(rcc.RCC_MINIMAL_CLEAN_TIME);
        }
    };

    getEnabledChannels = () => {
        return this.props.channelList.filter((channel) => channel.enabled);
    };

    getChannelFromList = (channelId) => {
        let channel;
        for (channel of this.props.channelList) {
            if (channel.id === channelId) {
                return channel;
            }
        }

        return null;
    };

    isChannelSelected = (channel) => {
        if (this.state.selectedChannels.length === 0) {
            return false;
        }

        let selectedChannel;
        for (selectedChannel of this.state.selectedChannels) {
            if (selectedChannel.id === channel.id) {
                return true;
            }
        }

        return false;
    };

    getColorantByChannel = (channel) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (channel.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getChannelBoxClass = (channel) => {
        if (this.isChannelSelected(channel)) {
            return "colorant-box active";
        }

        return "colorant-box";
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="general-colorant-select-box disabled">
                    <div key={channel.id} className="general-colorant-select-box-id">
                        {channel.id}
                    </div>
                    <div
                        className="general-colorant-select-box-color"
                        style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    />
                    <div className="general-colorant-select-box-name">{colorant !== null ? colorant.name : ""}</div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className={"general-colorant-select-box " + this.getChannelBoxClass(channel)}
                data-id={channel.id}
                onClick={this.handleToggleSelectChannelClick}
            >
                <div
                    key={channel.id}
                    data-id={channel.id}
                    onClick={this.handleToggleSelectChannelClick}
                    className="general-colorant-select-box-id"
                >
                    {channel.id}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    data-id={channel.id}
                />
                <div className="general-colorant-select-box-name" data-id={channel.id}>
                    {colorant !== null ? colorant.name : ""}
                </div>
            </div>
        );
    };

    getSelectAllButton = () => {
        if (this.state.selectedChannels.length < this.getEnabledChannels().length) {
            return (
                <button className="select-all-button btn btn-info pull-right" onClick={this.handleSelectAllClick}>
                    <Translate value="general.selectAll" />
                </button>
            );
        }

        return (
            <button className="select-all-button btn btn-info pull-right" onClick={this.handleClearClick}>
                <Translate value="general.clear" />
            </button>
        );
    };

    getStartCleaningButton = () => {
        return (
            <Button
                svgBefore={imgClean}
                onClick={this.handleStartCleaningClick}
                label={<Translate value="general.clean" />}
                disabled={!(this.state.selectedChannels.length > 0 && Number(this.state.cleaningTime) > 0)}
            />
        );
    };

    getChannelList = () => {
        return (
            <div className="general-wrapper-body general-colorant-select-box-wrapper slim-scroll">
                {this.props.channelList.map(this.getChannelBox)}
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 margin-bottom-10 flex flex-end font-size-2rem flex-align-center-vertical">
                    <Translate className="margin-right-5" value="cleanChannels.cleaningTime" />
                    <Input
                        className="col-2 primary-input"
                        type="text"
                        value={this.state.cleaningTime}
                        onFocus={this.handleCleaningTimeFocus}
                        onChange={this.handleCleaningTimeChange}
                        onBlur={this.handleCleaningTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_CLEANING_TIME)}
                        labelAfter={<span>s</span>}
                    />
                </div>
                <div className="general-wrapper flex-child">
                    <div className="general-wrapper-header flex margin-bottom-10 flex-align-center-vertical">
                        {translate("general.selectChannels")}
                        <Button
                            className="margin-left-auto"
                            onClick={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? this.handleSelectAllClick
                                    : this.handleClearClick
                            }
                            label={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? translate("general.selectAll")
                                    : translate("general.clear")
                            }
                        />
                    </div>
                    {this.getChannelList()}
                </div>
            </React.Fragment>,
            "flex-column"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getStartCleaningButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="cleanChannels.cleanChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        channelList: store.rcc.channelList,
        colorantList: store.global.colorantList,
        cleaningTime: store.settings.cleaningTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CLEAN_CHANNELS_MODAL));
        },
        dispatchCleanChannelsAction: (channels, cleaningTime) => {
            dispatch(rccActions.cleanChannels(channels, cleaningTime));
        },
        dispatchSetCleaningTimeAction: (cleaningTime) => {
            dispatch(settingsActions.setCleaningTime(cleaningTime));
        }
    };
};

export default CleanChannelsModal = connect(mapStoreToProps, mapDispatchToProps)(CleanChannelsModal);
